export interface EntityTileOutputModel {
  value: string;
  event: boolean;
}